import React, {Component,} from "react";
import GoogleAnalytics from "react-ga4";
import {GA_TRACKING_CODE} from "./constants/config";

GoogleAnalytics.initialize(GA_TRACKING_CODE);

const withTracker = (WrappedComponent, options = {}) => {
    const trackPage = page => {
        GoogleAnalytics.send({
            hitType: "pageview",
            page: page,
            ...options,
        });
    }

    // eslint-disable-next-line
    return class extends Component {
        componentDidMount() {
            // eslint-disable-next-line
            const page = this.props.location.pathname + this.props.location.search;
            trackPage(page);
        }

        componentDidUpdate(prevProps) {
            // eslint-disable-next-line
            const currentPage = prevProps.location.pathname + prevProps.location.search;
            // eslint-disable-next-line
            const nextPage = this.props.location.pathname + this.props.location.search;

            if (currentPage !== nextPage) {
                trackPage(nextPage);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
};

export default withTracker;